module.exports = __webpack_public_path__ + "static/media/scenario-paper.0ecd1753.svg";